// extracted by mini-css-extract-plugin
export var fileExt = "_uf-8";
export var fileIcon = "_uf-6";
export var fileLink = "_uf-5";
export var fileName = "_uf-7";
export var image = "_uf-1";
export var imageError = "_uf-3";
export var imageErrorIcon = "_uf-4";
export var imageLink = "_uf-0";
export var imageLoaded = "_uf-2";